<script lang="ts">var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c;
import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import CardBase from '../../../common/CardBase.svelte';
import { findSourceStore } from '../../../utilities';
import { Readable } from 'svelte/store';
import { CardsDataSourceRegistration } from '../../../common/CardsDataSourceRegistration';
import { onMount } from 'svelte';
import { JanusSignonManagerToken } from "../../../../../js/sso";
import { getToken } from 'inversify-token';
import ROOT from '../../../../../inversify.config';
import { ycSSOThirdPartyAuth } from '../../../../../js/ycapp';
import { resolveUrl } from '../../../../../js/url';
import { ycSSOSetState } from '../../../../../js/ycapp';
export let element;
export let sources;
export let sourceStore;
const signonManager = getToken(ROOT, JanusSignonManagerToken);
$: clientConfig = (_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.clientConfig;
//$: handleRedirect = element?.data?.handleRedirect as boolean || false;
$: baseUri = (clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.baseUri) || "https://www.example.com";
$: tenantId = (clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.tenantId) || "";
$: tenantIdParam = encodeURIComponent(tenantId);
$: redirectUri = (clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.redirectUri) || new URL("/modals/en/ProfileWithKOREBrandedUI", document.baseURI).href;
$: redirectUriParam = encodeURIComponent(redirectUri);
$: nextPage = ((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.nextPage) || undefined;
$: endWorkflow = (_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.endWorkflow;
onMount(() => __awaiter(void 0, void 0, void 0, function* () {
    function afterConnect() {
        if (endWorkflow) {
            signonManager.fireWorkflowEndEvent();
        }
        else if (nextPage) {
            resolveUrl(nextPage).func();
        }
        else {
            resolveUrl(`ConnectAccounts`).func();
        }
    }
    const tpaConfig = {
        url: `${baseUri}/dashboard/profile?tenantid=${tenantIdParam}`,
        redirectUri,
        redirectUriParams: ['returnvisitorurl', 'successredirecturl']
    };
    ycSSOThirdPartyAuth("OAUTH", tpaConfig, (method, clientResult) => __awaiter(void 0, void 0, void 0, function* () {
        console.log("ycSSOThirdPartyAuth callback inside OAUTH (KORE Branded UI)", method, clientResult);
        if (clientResult === null || clientResult === void 0 ? void 0 : clientResult.error) {
            //alert(clientResult.error);
            signonManager.fireWorkflowEndEvent();
            return;
        }
        afterConnect();
    }));
}));
</script>

<CardBase {element}>
</CardBase>
